/* eslint-disable @typescript-eslint/no-unused-vars */
import { CommonService } from "td_server/services";
import {
  setChadhavaVideos,
  setLoading,
  setPujaVideos,
  setTopFiveChadhavaTempleList,
  setTopFivePujaList,
  setTopFiveRatingsList,
} from "../slices/dashboardSlice";
import { PROMOVIDEOTYPE } from "../../utils/Constants";
import { trackedAsync } from "../../utils/analyics/trackedAsync";

export const getDashBoardDataFromBE = () => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));
    const response: any = await trackedAsync(()=> CommonService.getDashBoardData());
    dispatch(setTopFivePujaList(response?.topFivePujaList));
    dispatch(setTopFiveChadhavaTempleList(response?.topFiveChadhavaTempleList));
    dispatch(setTopFiveRatingsList(response?.topFiveRatingsList));

    dispatch(setLoading(false));
    return Promise.resolve(response);
  } catch (error: any) {
    dispatch(setLoading(false));
    return Promise.reject("");
  }
};

export const  getPromoVideoByType = (type:string,isGetDisabledVideo:boolean=false) => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));
    const response: any = await trackedAsync( ()=>CommonService.getPromoVideoByType(type,isGetDisabledVideo));
    if(!isGetDisabledVideo && response?.videos?.length){
      switch(type) {
        case PROMOVIDEOTYPE.puja:
          dispatch(setPujaVideos(response?.videos ?? []));
          break;
        case PROMOVIDEOTYPE.chadhava:
          dispatch(setChadhavaVideos(response?.videos ?? []));
          break;
        default:

      }

    }
    dispatch(setLoading(false));
    return Promise.resolve(response);
  } catch (error: any) {
    dispatch(setLoading(false));
    return Promise.reject("");
  }
};

export const addOrEditVideos = (type:string,pujaVideoList:any) => async (dispatch:any) =>{
  try {
    const response: any = await CommonService.addOrEditVideos(type?.trim(),(pujaVideoList));
    return Promise.resolve(response);
  } catch (error) {
    return Promise.reject("");
  }
}
